import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AllocationViewActionRequestUliModel } from '../models';

@Injectable({ providedIn: 'root' })
export class AllocationViewActionMediatorService {
  actionParams$: BehaviorSubject<AllocationViewActionRequestUliModel | null> =
    new BehaviorSubject<AllocationViewActionRequestUliModel | null>(null);
  setActionParams(params: AllocationViewActionRequestUliModel): void {
    this.actionParams$.next(params);
  }

  getCurrentTruckId(): number | null {
    return this.actionParams$.getValue()?.truckId ?? null;
  }

  clear(): void {
    this.actionParams$.next(null);
  }
}
